import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
// import ProjectList from './ProjectList';
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import { Redirect } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { Link } from 'react-router-dom'
import TaskForm from './TaskForm'
import TaskSummary from './TaskSummary'
import Typography from '@material-ui/core/Typography';
import Loader from '../../../components/custom/loader'
import { getCollection } from '../../../constant';

import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

class Tasks extends Component {

  state = {}
  
  constructor(props){
    super(props);
    this.state = {
      activeTab: 0,
      loading : true
    }
  }

  componentDidMount(){
    setTimeout(() => {
      this.setState({loading : false})
    }, 1000)
  }

  render() {
    const { project = {}, auth, tasks = [], taskId, profile } = this.props
    const { id } = project
    const { activeTab, loading } = this.state

    if (!auth.uid) return <Redirect to='/signin' />


    if (loading || !isLoaded(tasks) || !isLoaded(profile)) {
      return <Loader />
    }

    let active = 0;
    let closed = 0;

    tasks && tasks.forEach((task) => {
      if(task.complete) closed++;
      if(!task.complete) active++;
    })


    return (
      <div style={{ width: '80%', margin: 'auto', maxWidth: 900, marginTop: 10 }}>
        {
          (id && project && !project.complete)  ? <TaskForm project={project} />
            : (!taskId ? <Typography variant="h4">Tasks</Typography> : null)
        }
        <div style={{ clear: 'both', height: 1, width: '100%' }}></div>

        {
          !taskId && tasks && tasks.length > 0&&
          <div>
            <div style={{ clear: 'both', height: 20, width: '100%' }}></div>
            <Paper square>
              <Tabs
                value={activeTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(tab, val) => { this.setState({ activeTab: val }) }}
              >
                <Tab label={`Active Tasks(${active})`} />
                <Tab label={`Completed Tasks(${closed})`} />
              </Tabs>
            </Paper>
          </div>
        }

        {
          tasks && tasks.length  > 0 ? tasks.map((task) => {
              if (taskId) {
                if (taskId == task.id)
                  return <TaskSummary key={task.id || taskId} task={task} enableFullView={!taskId} profile={profile} />
                else return null;
              } else {
                if ((activeTab == 0) && !task.complete) {
                  return <TaskSummary key={task.id || taskId} task={task} enableFullView={!taskId} profile={profile} />
                } else if ((activeTab == 1) && task.complete) {
                  return <TaskSummary key={task.id || taskId} task={task} enableFullView={!taskId} profile={profile} />
                } else {
                  return null;
                }
              }
            })
            : <Typography variant="h5">There are no task(s) to show</Typography>
        }

        {
          tasks && tasks.length  > 0 && (activeTab == 0) && (active == 0) && <Typography style={{paddingTop:20}} variant="subtitle1">There is no active task</Typography>
        }
        {
          tasks && tasks.length  > 0 && (activeTab == 1) && (closed == 0) && <Typography style={{paddingTop:20}} variant="subtitle1">There is no completed task</Typography>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const taskId = ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.taskId
  const tasks = state.firestore.ordered[getCollection(state.firebase.profile, 'tasks')] || [];

  tasks.sort((a, b) => {
    return (b.updatedAt || b.createdAt) - (a.updatedAt || a.createdAt);
  });

  return {
    tasks: tasks && (taskId && tasks[taskId] ? [tasks[taskId]] : tasks),
    auth: state.firebase.auth,
    taskId,
    profile: state.firebase.profile,
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    if (props.taskId) {
      return [
        {
          collection: getCollection(props.profile, 'tasks'),
          doc: props.taskId,
        }
      ]
    } else if(props.user && props.user.id){
      return [
        {
          collection: getCollection(props.user, 'tasks'),
          where: [
            ['assigneeIds', 'array-contains', props.user.id],
            props.project  ? ['projectId', '==', props.user.id] : []
          ],
        },
      ]
    } else if (props.profile.role == 'Admin') {
      return [
        {
          collection: getCollection(props.profile, 'tasks'),
          where: props.project  ? ['projectId', '==', props.project.id] : null,
        },
      ]
    } else if (props.profile.id) {
      return [
        {
          collection: getCollection(props.profile, 'tasks'),
          where: [
            ['assigneeIds', 'array-contains', props.profile.id],
            props.project  ? ['projectId', '==', props.project.id] : []
          ],
        },
      ]
    } 
    else {
      return [];
    }
  })
)(Tasks)